import { NgModule } from '@angular/core';

import { SharedModule } from 'shared/shared.module';

import {
  ConnectionTypeNameComponent
} from './components/connection-type-name/connection-type-name.component';

const PAGES = [
];

const COMPONENTS = [
  ConnectionTypeNameComponent
];

const DIALOGS = [
];

@NgModule({
  imports: [
    SharedModule
  ],
  declarations: [
    ...COMPONENTS,
    ...DIALOGS
  ],
  providers: [],
  exports: [
    ...COMPONENTS,
    SharedModule
  ]
})
export class ConnectionTypesSharedModule { }
